import React, {useState, useEffect, useRef} from "react";
import {useObserver} from "mobx-react-lite";
import {useHistory} from "react-router-dom";
import {Col, Input, Row, Table, Tag, Badge, Button} from "antd";
import {CheckOutlined} from "@ant-design/icons";
import {MultipleSelect} from "../../_defaultComponents/MultipleSelect/MultipleSelect";
import {useStore} from "../../../hooks/useStore";
import {useFetch} from "../../../hooks/useFetch";
import {useWindowSize} from "../../../hooks/useWindowSize";
import {TableContainer, TableText, DedicationTitle} from "./mulitpleDedicationStyles";
import {useTranslation} from "react-i18next";
import { EmptyMessage } from "../../_defaultComponents/EmptyMessage/EmptyMessage";

const {Column} = Table;

export const MultipleDedication = () => {
    const history = useHistory();
    const stores = useStore();
    const windowSize = useWindowSize();
    const {t} = useTranslation();

    const {width} = windowSize;

    const [currentPage, setCurrentPage] = useState(1);
    const [courierSelectData, setCourierSelectData] = useState({});
    const [recall, setRecall] = useState(true);
    const [triggerButton, setTriggerButton] = useState(false);

    const recallRef = useRef(recall);

    const [loading, dedicationList, setDedicationList, setLoading] = useFetch({
        defaultDataValue: {},
        fetchFn: stores.courierStore.getDedicationList.bind(null, {
            limit: 1000,
            skip: 0
        }),
        dependencies: [recall]
    });

    const onChangeMultipleSelect = e => {
        //TODO: Have to review these set operations: setTriggerButton, tempCourierSelectData
        let tempCourierSelectedData = courierSelectData;
        tempCourierSelectedData[e.courierId] = e;
        setCourierSelectData();
        setCourierSelectData(tempCourierSelectedData);
        setTriggerButton(!triggerButton); // this is for re-rendering "courierUpdateDedication" button.
    };

    return useObserver(() => (
        <React.Fragment>
            <TableContainer
                small={"large"}
                loading={loading}
                dataSource={dedicationList?.data?.rows}
                rowKey="_id"
                pagination={{
                    total: dedicationList?.data?.dataCount,
                    current: currentPage,
                    onChange: async page => {
                        setCurrentPage(page);
                        history.push("/couriers/multiple-dedication?page=" + page);
                    }
                }}
                locale={{
                    emptyText: <EmptyMessage/>
                }}
            >
                <Column
                    align="center"
                    title={t("fields.courierName", {ns: "common"})}
                    dataIndex="fullname"
                />
                <Column
                    align="center"
                    title={() =>
                        Boolean(width) && (
                            <Row>
                                <DedicationTitle width={width / 7.5}>
                                    {t("fields.company", {ns: "common"})}
                                </DedicationTitle>
                                <DedicationTitle width={width / 3.2}>
                                    {t("fields.regionGroup", {ns: "common"})}
                                </DedicationTitle>
                                <DedicationTitle width={width / 4.5}>
                                    {t("fields.subcompany", {ns: "common"})}
                                </DedicationTitle>
                            </Row>
                        )
                    }
                    dataIndex="index"
                    render={(tag, index) => (
                        <MultipleSelect
                            key={index}
                            direction={"horizontal"}
                            data={index}
                            hideTitle={true}
                            list={[
                                {
                                    key: "company",
                                    value: t("fields.company", {ns: "common"}),
                                    width: width / 7.5
                                },
                                {
                                    key: "region",
                                    value: t("fields.region", {ns: "common"}),
                                    width: width / 3.2
                                },
                                {
                                    key: "subcompany",
                                    value: t("fields.subcompany", {ns: "common"}),
                                    width: width / 4.5
                                },
                                {
                                    key: "slotCourier",
                                    value: t("fields.slotCourier", {ns: "common"}),
                                    width: width / 1.8
                                }
                            ]}
                            onChange={onChangeMultipleSelect}
                        />
                    )}
                />
                <Column
                    dataIndex="_id"
                    render={id =>
                        courierSelectData[id] && (
                            <Button
                                type="primary"
                                onClick={async () => {
                                    await stores.courierStore.courierUpdateDedication({
                                        ...courierSelectData[id],
                                        id
                                    });
                                    setRecall(!recallRef.current);
                                }}
                                icon={<CheckOutlined />}
                            >
                                {t("actions.save", {ns: "common"})}
                            </Button>
                        )
                    }
                />
            </TableContainer>
        </React.Fragment>
    ));
};
